var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.7046,
    y: 1.52344,
    width: 5.13281,
    height: 7.45312,
    rx: 0.9,
    fill: "url(#paint0_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7046,
    y: 1.52344,
    width: 5.13281,
    height: 7.45312,
    rx: 0.9,
    fill: "url(#paint1_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7046 8.25V2.27344H17.2134V8.25H12.7046Z",
    fill: "url(#paint2_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7046 8.25V2.27344H17.2134V8.25H12.7046Z",
    fill: "url(#paint3_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7046 8.25V2.27344H17.2134V8.25H12.7046Z",
    fill: "url(#paint4_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7046 8.25V2.27344H17.2134V8.25H12.7046Z",
    fill: "url(#paint5_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1522_4620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9958 4.44801C15.9958 4.0528 16.3162 3.73242 16.7114 3.73242H17.3685C17.7637 3.73242 18.084 4.0528 18.084 4.44801C18.084 4.84321 17.7637 5.16359 17.3685 5.16359C17.7635 5.16379 18.0835 5.48409 18.0835 5.87918C18.0835 6.19424 17.8799 6.46174 17.5971 6.55728C17.8802 6.65265 18.0841 6.92031 18.0841 7.23559C18.0841 7.63079 17.7637 7.95117 17.3685 7.95117H16.7115C16.3163 7.95117 15.9959 7.63079 15.9959 7.23559C15.9959 6.9365 16.1794 6.68026 16.4399 6.57332C16.1291 6.4954 15.8989 6.21417 15.8989 5.87918C15.8989 5.48397 16.2193 5.16359 16.6145 5.16359H16.7111C16.316 5.1634 15.9958 4.84309 15.9958 4.44801Z",
    fill: "url(#paint6_linear_1522_4620)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.4647 5.47266C11.9173 5.47266 11.4736 5.91469 11.4736 6.45996C11.4736 6.46488 11.4737 6.46979 11.4737 6.47469L11.4736 8.48789C11.4736 9.16432 11.8644 9.74981 12.4334 10.0325C12.612 10.1212 12.7349 10.3091 12.6955 10.504L12.4735 11.6016H16.4966L16.7782 10.5353C16.8231 10.3654 16.9451 10.2261 17.1081 10.1589L17.6352 9.97601C17.9665 9.87694 18.2745 9.51133 18.3845 9.08746L18.4346 8.87109L17.7235 8.91118C17.6248 8.90706 17.5274 8.92671 17.43 8.94633C17.3933 8.95373 17.3561 8.96123 17.3193 8.96733C17.2828 8.9734 17.2453 8.97656 17.207 8.97656H13.4099C13.0357 8.97656 12.7323 8.67435 12.7323 8.30156V7.69727C12.7323 7.55919 12.8442 7.44727 12.9823 7.44727H13.5528C14.1001 7.44727 14.5439 7.00523 14.5439 6.45996C14.5439 5.91469 14.1001 5.47266 13.5528 5.47266H12.4647Z",
    fill: "#F6C32F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4647 5.47266C11.9173 5.47266 11.4736 5.91469 11.4736 6.45996C11.4736 6.46488 11.4737 6.46979 11.4737 6.47469L11.4736 8.48789C11.4736 9.16432 11.8644 9.74981 12.4334 10.0325C12.612 10.1212 12.7349 10.3091 12.6955 10.504L12.4735 11.6016H16.4966L16.7782 10.5353C16.8231 10.3654 16.9451 10.2261 17.1081 10.1589L17.6352 9.97601C17.9665 9.87694 18.2745 9.51133 18.3845 9.08746L18.4346 8.87109L17.7235 8.91118C17.6248 8.90706 17.5274 8.92671 17.43 8.94633C17.3933 8.95373 17.3561 8.96123 17.3193 8.96733C17.2828 8.9734 17.2453 8.97656 17.207 8.97656H13.4099C13.0357 8.97656 12.7323 8.67435 12.7323 8.30156V7.69727C12.7323 7.55919 12.8442 7.44727 12.9823 7.44727H13.5528C14.1001 7.44727 14.5439 7.00523 14.5439 6.45996C14.5439 5.91469 14.1001 5.47266 13.5528 5.47266H12.4647Z",
    fill: "url(#paint7_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4647 5.47266C11.9173 5.47266 11.4736 5.91469 11.4736 6.45996C11.4736 6.46488 11.4737 6.46979 11.4737 6.47469L11.4736 8.48789C11.4736 9.16432 11.8644 9.74981 12.4334 10.0325C12.612 10.1212 12.7349 10.3091 12.6955 10.504L12.4735 11.6016H16.4966L16.7782 10.5353C16.8231 10.3654 16.9451 10.2261 17.1081 10.1589L17.6352 9.97601C17.9665 9.87694 18.2745 9.51133 18.3845 9.08746L18.4346 8.87109L17.7235 8.91118C17.6248 8.90706 17.5274 8.92671 17.43 8.94633C17.3933 8.95373 17.3561 8.96123 17.3193 8.96733C17.2828 8.9734 17.2453 8.97656 17.207 8.97656H13.4099C13.0357 8.97656 12.7323 8.67435 12.7323 8.30156V7.69727C12.7323 7.55919 12.8442 7.44727 12.9823 7.44727H13.5528C14.1001 7.44727 14.5439 7.00523 14.5439 6.45996C14.5439 5.91469 14.1001 5.47266 13.5528 5.47266H12.4647Z",
    fill: "url(#paint8_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4647 5.47266C11.9173 5.47266 11.4736 5.91469 11.4736 6.45996C11.4736 6.46488 11.4737 6.46979 11.4737 6.47469L11.4736 8.48789C11.4736 9.16432 11.8644 9.74981 12.4334 10.0325C12.612 10.1212 12.7349 10.3091 12.6955 10.504L12.4735 11.6016H16.4966L16.7782 10.5353C16.8231 10.3654 16.9451 10.2261 17.1081 10.1589L17.6352 9.97601C17.9665 9.87694 18.2745 9.51133 18.3845 9.08746L18.4346 8.87109L17.7235 8.91118C17.6248 8.90706 17.5274 8.92671 17.43 8.94633C17.3933 8.95373 17.3561 8.96123 17.3193 8.96733C17.2828 8.9734 17.2453 8.97656 17.207 8.97656H13.4099C13.0357 8.97656 12.7323 8.67435 12.7323 8.30156V7.69727C12.7323 7.55919 12.8442 7.44727 12.9823 7.44727H13.5528C14.1001 7.44727 14.5439 7.00523 14.5439 6.45996C14.5439 5.91469 14.1001 5.47266 13.5528 5.47266H12.4647Z",
    fill: "url(#paint9_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4647 5.47266C11.9173 5.47266 11.4736 5.91469 11.4736 6.45996C11.4736 6.46488 11.4737 6.46979 11.4737 6.47469L11.4736 8.48789C11.4736 9.16432 11.8644 9.74981 12.4334 10.0325C12.612 10.1212 12.7349 10.3091 12.6955 10.504L12.4735 11.6016H16.4966L16.7782 10.5353C16.8231 10.3654 16.9451 10.2261 17.1081 10.1589L17.6352 9.97601C17.9665 9.87694 18.2745 9.51133 18.3845 9.08746L18.4346 8.87109L17.7235 8.91118C17.6248 8.90706 17.5274 8.92671 17.43 8.94633C17.3933 8.95373 17.3561 8.96123 17.3193 8.96733C17.2828 8.9734 17.2453 8.97656 17.207 8.97656H13.4099C13.0357 8.97656 12.7323 8.67435 12.7323 8.30156V7.69727C12.7323 7.55919 12.8442 7.44727 12.9823 7.44727H13.5528C14.1001 7.44727 14.5439 7.00523 14.5439 6.45996C14.5439 5.91469 14.1001 5.47266 13.5528 5.47266H12.4647Z",
    fill: "url(#paint10_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1522_4620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.584 11.2969C12.2046 11.2969 11.8659 11.5348 11.7373 11.8918L10.2193 16.1047C10.1389 16.3278 9.92727 16.4766 9.69013 16.4766H1.94854C1.70001 16.4766 1.49854 16.678 1.49854 16.9266V21.9797C1.49854 22.2282 1.70001 22.4297 1.94854 22.4297H11.877C13.19 22.4297 14.3505 21.5757 14.7411 20.3221L17.25 12.27C17.4005 11.7872 17.0397 11.2969 16.534 11.2969H12.584Z",
    fill: "#E83896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.584 11.2969C12.2046 11.2969 11.8659 11.5348 11.7373 11.8918L10.2193 16.1047C10.1389 16.3278 9.92727 16.4766 9.69013 16.4766H1.94854C1.70001 16.4766 1.49854 16.678 1.49854 16.9266V21.9797C1.49854 22.2282 1.70001 22.4297 1.94854 22.4297H11.877C13.19 22.4297 14.3505 21.5757 14.7411 20.3221L17.25 12.27C17.4005 11.7872 17.0397 11.2969 16.534 11.2969H12.584Z",
    fill: "url(#paint11_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.584 11.2969C12.2046 11.2969 11.8659 11.5348 11.7373 11.8918L10.2193 16.1047C10.1389 16.3278 9.92727 16.4766 9.69013 16.4766H1.94854C1.70001 16.4766 1.49854 16.678 1.49854 16.9266V21.9797C1.49854 22.2282 1.70001 22.4297 1.94854 22.4297H11.877C13.19 22.4297 14.3505 21.5757 14.7411 20.3221L17.25 12.27C17.4005 11.7872 17.0397 11.2969 16.534 11.2969H12.584Z",
    fill: "url(#paint12_linear_1522_4620)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.1792,
    y: 7.95117,
    width: 2.27051,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint13_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1792,
    y: 7.95117,
    width: 2.27051,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint14_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1792,
    y: 7.95117,
    width: 2.27051,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint15_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1792,
    y: 7.95117,
    width: 2.27051,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint16_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1792,
    y: 7.95117,
    width: 2.27051,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint17_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2407,
    y: 3.44531,
    width: 2.66602,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint18_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2407,
    y: 3.44531,
    width: 2.66602,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint19_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2407,
    y: 3.44531,
    width: 2.66602,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint20_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2407,
    y: 6.50391,
    width: 2.66602,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint21_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2407,
    y: 6.50391,
    width: 2.66602,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint22_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2407,
    y: 6.50391,
    width: 2.66602,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint23_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2407,
    y: 6.50391,
    width: 2.66602,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint24_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1177,
    y: 5.01562,
    width: 2.78906,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint25_linear_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1177,
    y: 5.01562,
    width: 2.78906,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint26_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1177,
    y: 5.01562,
    width: 2.78906,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint27_radial_1522_4620)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1177,
    y: 5.01562,
    width: 2.78906,
    height: 1.57031,
    rx: 0.785156,
    fill: "url(#paint28_linear_1522_4620)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1522_4620",
    x: 15.3989,
    y: 3.23242,
    width: 3.18506,
    height: 5.21875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1522_4620"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1522_4620",
    x: 1.49854,
    y: 11.2969,
    width: 16.7861,
    height: 12.1328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.215686 0 0 0 0 0.380392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1522_4620"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_4620",
    x1: 15.543,
    y1: 4.24748,
    x2: 18.0558,
    y2: 1.8808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48427D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1522_4620",
    x1: 15.271,
    y1: 9.17355,
    x2: 15.271,
    y2: 8.58768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312D58",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0483 3.59021) rotate(101.077) scale(5.66961 4.55078)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1522_4620",
    x1: 17.3774,
    y1: 5.47046,
    x2: 16.8501,
    y2: 5.47046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CEDFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1522_4620",
    x1: 12.6796,
    y1: 5.26172,
    x2: 13.001,
    y2: 5.26172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E98C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E98C5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5002 7.01367) rotate(21.8838) scale(1.57203 1.18596)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#267BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#267BAE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1522_4620",
    x1: 16.4564,
    y1: 7.95117,
    x2: 16.4564,
    y2: 4.26687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E74A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5192B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7288 9.30469) rotate(180) scale(2.39971 2.49688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.424959,
    stopColor: "#F09B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09B4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1863 8.91099) rotate(-13.0745) scale(1.65275 9.48029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09B4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7715 7.62307) rotate(-90) scale(1.28793 2.47678)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09B4C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.1678 6.26084) rotate(135) scale(0.665512 0.755864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6118 11.2969) rotate(140.064) scale(2.62876 0.690873)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF99B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF99B6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1522_4620",
    x1: 8.30713,
    y1: 23.1094,
    x2: 8.30713,
    y2: 20.3906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF42C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF42C3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1978 8.73633) rotate(180) scale(1.72266 1.10548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA504"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1353 8.51953) rotate(145.169) scale(0.492422 0.443732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8698 8.73633) scale(0.688638 1.28906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD9D52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1522_4620",
    x1: 17.3145,
    y1: 7.95117,
    x2: 17.3145,
    y2: 8.16211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D68C02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D68C02",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1522_4620",
    x1: 17.3145,
    y1: 9.19582,
    x2: 17.3145,
    y2: 9.61687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB8F72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8F72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1522_4620",
    x1: 17.5737,
    y1: 3.44531,
    x2: 17.5737,
    y2: 5.01562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AF24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5376 4.01367) rotate(149.349) scale(0.551684 0.465058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE064",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8774 4.23047) scale(0.808594 1.28906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD9D52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6109 7.28906) rotate(180) scale(2.02273 1.10548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA504"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5376 7.07227) rotate(149.349) scale(0.551684 0.465058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8774 7.28906) scale(0.808594 1.28906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD9D52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1522_4620",
    x1: 17.5737,
    y1: 6.46875,
    x2: 17.5737,
    y2: 6.69141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D68C02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D68C02",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1522_4620",
    x1: 17.5122,
    y1: 5.01562,
    x2: 17.5122,
    y2: 6.58594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AF24"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5206 5.58398) rotate(150.471) scale(0.570638 0.470362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE064",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1522_4620",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7376 5.80078) scale(0.845914 1.28906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD9D52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1522_4620",
    x1: 17.5122,
    y1: 4.92187,
    x2: 17.5122,
    y2: 5.20313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D68C02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D68C02",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandEmoji);
export default __webpack_public_path__ + "static/media/HandEmoji.89bdc6cc17b779e5322e62ebc88f2ffb.svg";
export { ForwardRef as ReactComponent };